import { render, staticRenderFns } from "./TagContextMenu.vue?vue&type=template&id=528dcc8e&lang=pug"
import script from "./TagContextMenu.vue?vue&type=script&lang=js"
export * from "./TagContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports